/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IStreamStatus {
        networkNodeHref?: string;
        status?: IStreamInnerStatus;
    }

    export interface IStreamInnerStatus {
        connectionusage?: IStreamConnectionStatus;
        imaliveplusplus?: IStreamAliveStatus;
        clientstatuspms?: IStreamClientStatus;
    }

    export interface IStreamConnectionStatus {
        data?: IStreamConnectionData[];
        dataDate?: Date;
        dataTimeMS?: number;
    }

    export interface IStreamConnectionData {
        cid: string;
        id: string;
        type: string;
        send_total: number;
        recv_total: number;
    }

    export interface IStreamAliveStatus {
        data?: IStreamAliveData[];
        dataDate?: Date;
        dataTimeMS?: number;
    }

    export interface IStreamAliveData {
        options: Object; // fIXME?: options are dynamic
        name: string;
        selected: string;
        display_name: string;
    }

    export interface IStreamClientStatus {
        data?: {
            connectedtowmtserver?: boolean;
            connectedclientserial?: string;
            stats?: {
                RecvBytes: number;
            };
            gps?: {
                numstats: number;
                long: number;
                lat: number;
                alt: number;
            };
            isIO?: boolean;
            connectionstatus?: IClientStatusConnectionStatus[];
        };
        dataDate?: Date;
        dataTimeMS?: number;
    }

    export interface IClientStatusConnectionStatus {
        LinkStatus?: string;
        SigLevel?: string;
        Loss?: string;
        Location?: string;
        RatActive?: string;
        Rtt?: string;
        SignalIndicator?: string;
        ConnectionNo?: number;
        Enabled?: string;
        TransportType?: string;
        RatAvailable?: string;
        BitRate?: number;
    }

    export interface ITrendingResult {
        device: string;
        values: IBitRateTrending[];
        paramName: string;
        unit: string;
    }

    export interface IBitRateTrending {
        date: string;
        bitrate: number;
        minValue: number;
        maxValue: number;
        synthetic: boolean;
        frontSynth?: boolean;
    }

    export interface IPlotPoint {
        time: number;
        value: number;
        synthetic: boolean;
    }

    export class StreamStatus implements IStreamStatus {
        public networkNodeHref: string;
        public status: IStreamInnerStatus;

        public static Empty(): StreamStatus {
            return new StreamStatus();
        }

        constructor() {
            // empty constructor
            this.networkNodeHref = '';
            this.status = undefined;
        }
    }
}